// extracted by mini-css-extract-plugin
export default {"container":"FormSuggestions_container__JvtIj","suggestion":"FormSuggestions_suggestion__cxYIA"};